"use strict";

require("../scss/common.scss");

import $ from "jquery";

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from "angular";
import uiRouter from "@uirouter/angularjs";
import ngCookies from "angular-cookies";

import videogular from "videogular";
import videogularControlls from "videogular-controls";
import videogularBuffering from "videogular-buffering";
import videogularOverlayPlay from "videogular-overlay-play";
import videogularThemesDefault from "videogular-themes-default";

import angularUtilsPagination from "angular-utils-pagination";

import infiniteScroll from "ng-infinite-scroll";

import { core } from "site_core";

import factories from "./factories";
import controllers from "./features";

// Our Modules
import appRoutes from "./app.routes";
import appRun from "./app.run";
import appDirectives from "./app.directive.config.js";

("ngInject");
var app = angular.module("site", [
  angularUtilsPagination,
  uiRouter,
  ngCookies,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll,
  factories,
  controllers
]);

app.config(["$provide", appDirectives]);
app.config(appRoutes);
app.run(appRun);

app.constant("BASE_URLS", { API: API_URL, CONTENT: CONTENT_URL });

app.constant("siteConst", {
  id: 9,
  urlShort: "StrictlyEnglishOnline.com",
  urlLong: "http://www.StrictlyEnglishOnline.com",
  urlMed: "www.StrictlyEnglishOnline.com",
  name: "Strictly English Online",
  logoLarge: "images/logo_small.png",
  logoSmall: "images/logo_xsmall.png",
  warningBanner: "images/warning_banner.png",
  members: {
    banner: {
      image: "images/member_video_banner.jpg",
      caption: "<p>Welcome to Our Exclusive</p> <h2>members area!</h2>"
    },
    images: {
      showImages: true,
      rowCount: 5
    }
  },
  twoTwoFiveSevenAddress: "5400 W. 64th Ave Arvada, CO 80007",
  webmasterEmail: "webmaster@strictlyenglishonline.com",
  metaDescription:
    "Amateur Spanking Videos and a Variety of Spanking Videos from the top British Producer Strictly English.",
  tagline: {
    topLine: "TOP CLASSIC BRITISH SPANKING SITE FROM STRICTLY ENGLISH!",
    secondLine:
      "UK Spanking Video and Spanking Pictures at their Finest. Featuring School Discipline Spanking Videos of Naughty School Girls. Join now for Tons of Spanking Content."
  },
  footerTagline: {
    banner: "",
    bannerDetails: "",
    getPassword:
      '<h4><a href="/join">get your password to our exclusive members area</a></h4> <p>If you want to see some of the hardest and real disciplinary spanking in the world with the top spanking models of today and yesterday, you have come to the right place!</p>'
  },
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  slider: {
    image: "images/slider.jpg",
    title: "Over 350 Videos",
    name: "Updated 2x a Week",
    descr: "Exclusive Videos you will not find anywhere else",
    linkText: "instant access!"
  },
  advert: {
    tour: [
      "Authentic Bare Bottom Schoolgirl Canings",
      "Exclusive Caning Videos and Caning Pictures",
      "Full Updates Twice a Week",
      "Unlimited Streaming and Downloads",
      "HD/SD Mobile and Tablet Ready"
    ],
    trailer: [
      "M/F and F/F Spanking Videos",
      "Huge Variety of Spanking Clips",
      "British Spanking Punishments",
      "Up to 6 Updates a Week",
      "Unlimited Streaming and Downloads",
      "HD/SD Mobile and Tablet Ready",
      "OTK and Slipper Spanking Movies",
      "Huge Collection of Spanking Models",
      "Schoolgirl Hairbrush Spankings"
    ]
  },
  join: {
    ccbill: {
      key: "903b42a0-5379-4f67-843a-68bbea000a29"
      // @TODO add products to ccbill
    },
    cco: {
      accountId: 9309,
      siteId: 58643,
      products: [
        {
          price: 29.95,
          text:
            '<span class="days"> 30 Day Membership <span>Rebills every 30 days at $24.95</span> </span> <span class="price"><sup>$</sup>24<sup>.95</sup></span>',
          productId: 79286
        },
        {
          price: 59.95,
          text:
            '<span class="days"> 90 Day Membership <span>Rebills every 90 days at $59.95</span> </span> <span class="price"><sup>$</sup>59<sup>.95</sup></span>',
          productId: 79287
        },
        {
          price: 99.95,
          text:
            '<span class="days"> 180 Day Membership <span>One Time Purchase - Non Recurring</span> </span> <span class="price"><sup>$</sup>99<sup>.95</sup></span>',
          productId: 79385
        }
      ]
    }
  },
  members: {
    video: {
      labels: false
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js